import _sortBy from 'lodash/sortBy';

function getSectionListData(pages, sections, settings) {
    const pageSortBySeq = _sortBy(
        pages.filter(page => !page.deleted),
        'seq'
    );
    return pageSortBySeq.map(page => {
        const sortSections = _sortBy(
            sections.filter(section => section.pageId === page.id),
            'seq'
        ).map(section => {
            return {
                ...settings.sections.find(setting => setting.id === section.id),
                type: section.type,
                deleted: section.deleted,
                globalSectionId: section.globalSectionId
            };
        });
        return {
            pageId: page.id,
            pageType: page.type,
            sections: [...sortSections]
        };
    });
}

export default getSectionListData;
